export default __webpack_public_path__ + "static/media/loading.1ba1ab43.gif";